/** Edits a simple TravelRequest. To generate a request from a response, see `./offerResponseToRequest.js`
 * This is a bound component - it does not store the edited request in its own stat, but relies on
 * the 'request' and 'onRequestChange' props entirely. */

import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { List, Map } from "immutable";
import moment from "moment";
import { withProps } from "recompose";
import addNewLeg from "./addNewLeg";
// import { DropdownButton, MenuItem } from 'react-bootstrap'
import DatePicker from "react-16-bootstrap-date-picker";
import AirportInput from "./AirportInput";
import Participants from "./Participants";
import { addParticipantWithAgeGroup, remParticipantWithAgeGroup } from "./participants-utils";

const FlightRequirementEditor = ({
  request = List(),
  airportByIata = Map(),
  // Request update functionality
  remLeg,
  addLeg,
  seatClassChange,
  locationChange,
  dateChange,
  addParticipant,
  remParticipant,
  onNewAirports
}) => {
  return (
    <div className="container trip-request-form flights-request-form">
      <div className="travel-info legs-info">
        <div className="legs-rows">
          {request.get("required", List()).map((r = Map(), i) => {
            if (!r.has("departureDate")) {
              r = r.set("departureDate", moment().format("YYYY-MM-DD"));
            }

            const previousLegDate =
              i === 0
                ? moment()
                : moment(
                    request
                      .get("required")
                      .get(i - 1)
                      .get("departureDate")
                  );
            const minDate = previousLegDate.format();

            return (
              <div className="row form-row" key={i}>
                <div className="col-xs-24 leg-header">
                  <h3>{i + 1}</h3>
                  {request.get("required", List()).size > 1 && <a onClick={remLeg(i)} style={{cursor:"pointer"}} className="del-btn" title="Delete flight">&nbsp;</a>}
                </div>
                <div className="col-xs-24 col-md-8 col-sm-12">
                  <div className="col-wrapper-va">
                    <AirportInput
                      id={'From IATA'}
                      iataCode={r.get("from")}
                      airportByIata={airportByIata}
                      onChange={locationChange(i)("from")}
                      className="pic pic-flight-from"
                      placeholder="From"
                      onNewAirports={onNewAirports}
                    />
                  </div>
                </div>
                <div className="col-xs-24 col-md-8 col-sm-12">
                  <div className="col-wrapper-va">
                    <AirportInput
                      id={'To IATA'}
                      iataCode={r.get("to")}
                      airportByIata={airportByIata}
                      onChange={locationChange(i)("to")}
                      className="pic pic-flight-to"
                      placeholder="To"
                      onNewAirports={onNewAirports}
                    />
                  </div>
                </div>
                <div className="col-xs-24 col-md-4 col-sm-12">
                  <div className="col-wrapper-va">
                    {/* <input
                                    placeholder="Date"
                                    className="pic pic-date"
                                    type="text"
                                    value={moment(r.get('departureDate')).format('DD MMM YY')} /> */}
                    <div className="input-group" style={{ width: "100%" }}>
                      <DatePicker
                        id={`flight${i}date`}
                        dateFormat="YYYY-MM-DD"
                        value={r.get("departureDate")}
                        minDate={minDate}
                        onChange={dateChange(i)}
                        showClearButton={false}
                        showTodayButton={true}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-3 col-sm-8">
                            <div className="col-wrapper-va">
                                <select name="departure-time">
                                    <option>Any time</option>
                                    <option>00:00</option>
                                    <option>01:00</option>
                                    <option>02:00</option>
                                    <option>03:00</option>
                                    <option>04:00</option>
                                    <option>05:00</option>
                                    <option>06:00</option>
                                    <option>07:00</option>
                                    <option>08:00</option>
                                    <option>09:00</option>
                                    <option>10:00</option>
                                    <option>11:00</option>
                                    <option>12:00</option>
                                    <option>13:00</option>
                                    <option>14:00</option>
                                    <option>15:00</option>
                                    <option>16:00</option>
                                    <option>17:00</option>
                                    <option>18:00</option>
                                    <option>19:00</option>
                                    <option>20:00</option>
                                    <option>21:00</option>
                                    <option>22:00</option>
                                    <option>23:00</option>
                                </select>
                            </div>
                        </div> */}
                <div className="col-xs-24 col-md-4 col-sm-12">
                  <div className="col-wrapper-va">
                    <div className="input-group" style={{ width: "100%" }}>
                      <select name="flight-class" className="flight-class-select" value={r.get("cabinClass")} onChange={seatClassChange(i)}>
                        <optgroup label="Seat class:">
                          <option value="BUSINESS">Business</option>
                          <option value="ECONOMY">Economy/Coach</option>
                        </optgroup>
                      </select>
                    </div>
                  </div>
                </div>
                {/* <div className="col-xs-12 col-md-4 col-sm-8">
                            <div className="col-wrapper-va">
                                <Participants participants={request.get('participants')}/>
                            </div>
                        </div> */}
              </div>
            );
          })}
          {/* <div className="row form-row">
                    <DropdownButton
                        title="Travellers"
                        id="travellers-dropdown"
                    >
                        <MenuItem eventKey="1">Action</MenuItem>
                        <MenuItem eventKey="2">Another action</MenuItem>
                        <MenuItem eventKey="3" active>Active Item</MenuItem>
                        <MenuItem divider />
                        <MenuItem eventKey="4">Separated link</MenuItem>
                    </DropdownButton>
                </div> */}
        </div>
        <div className="row">
          <div className="col-xs-24">
            <a className="add-btn-link pull-right" style={{ padding: "3px",cursor:"pointer" }} onClick={addLeg}>
              <span>Add another flight</span> <i className="plus-btn" />
            </a>
            <Participants participants={request.get("participants")} addParticipant={addParticipant} remParticipant={remParticipant} />
          </div>
        </div>
      </div>
    </div>
  );
};

FlightRequirementEditor.propTypes = {
  // The travel request to display / edit
  request: ImmutablePropTypes.map,
  // Map<IataCode, AirportDetail> - optional
  airportByIata: ImmutablePropTypes.map,
  // Called if user makes any changes to request. TravelRequest -> ()
  onRequestChange: PropTypes.func.isRequired
};

/** Constructs the fine-grained editing functions that the UI needs, and maps them
 * to higher-level 'on change' callback.
 */
const fineGrainedEditCallbacks = ({ request = Map(), onRequestChange }) => ({
  // Produces a click event handler that removes a particular leg
  remLeg: index => evt => {
    evt.preventDefault();
    onRequestChange(request.deleteIn(["required", index]));
  },

  // Produces a click hander that adds a leg. Delegates pre-population to
  // separate function
  addLeg: evt => {
    evt.preventDefault();
    onRequestChange(addNewLeg(request));
  },

  // Produces a drop-down menu change handler to set seat class
  seatClassChange: index => evt => {
    onRequestChange(request.setIn(["required", index, "cabinClass"], evt.target.value));
  },

  // Produces a text field change handler that changes 'from' or 'to' location of indicated leg
  locationChange: index => fromTo => iata => {
    onRequestChange(request.setIn(["required", index, fromTo], iata));
  },

  // Produces a no-input event handler that adds a participant of the given age group
  addParticipant: ageGroup => () => {
    onRequestChange(request.updateIn(["participants", "participant"], addParticipantWithAgeGroup(ageGroup)));
  },

  // Produces a no-input event handler that adds a participant of the given age group
  remParticipant: ageGroup => () => {
    onRequestChange(request.updateIn(["participants", "participant"], remParticipantWithAgeGroup(ageGroup)));
  },

  // Produces a react-bootstrap-date-picker onChange handler to accept
  // the new departure date for the indicated leg
  dateChange: index => isoDate => {
    isoDate = moment(isoDate).format("YYYY-MM-DD"); // ignore time
    
    request = request.setIn(["required", index, "departureDate"], isoDate);
    for (let i = index + 1; i < request.get("required").count(); i++) {
      if (moment(request.getIn(["required", i, "departureDate"])).isBefore(moment(isoDate))) {
        request = request.setIn(["required", i, "departureDate"], isoDate);
      }
    }
    onRequestChange(request);
  }
});

export default withProps(fineGrainedEditCallbacks)(FlightRequirementEditor);



// WEBPACK FOOTER //
// ./src/ndc/request/FlightRequirementEditor.js